<!-- <div class="my-container">
	<ng-template #customLoadingTemplate>
	  <div class="custom-class">

	  </div>
	</ng-template>

	<ngx-loading
	  [show]="loading"
	  [config]="{

		primaryColour: primaryColour,
        secondaryColour: secondaryColour,
        tertiaryColour: primaryColour,
        backdropBorderRadius: '3px'
	   }"
	  [template]="customLoadingTemplate"
	></ngx-loading>
  </div> -->
<div class="bredcrumbWrp">
  <!-- <ul>
          <li>
              <a routerLink="/customer-portal/profile">
                  Profile
              </a>
          </li>
          <li>Profile</li>
      </ul> -->
</div>
<div class="pageWrapper wrappInside">
  <div class="formsDeatais companyDetails">
    <mat-tab-group class="customTabs" dynamicHeight (selectedTabChange)="onTabClick($event)">
      <mat-tab label="Company" *ngIf="companyTab">
        <div class="tabInner">
          <form [formGroup]="companyProfileForm">
            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-12">
                <lucide-icon name="Building" class="user_icon"></lucide-icon>
                Company Details
              </h4>
              <div class="row">
                <!-- <div class="col-md-3">
                                      <div class="formGroup">
                                          <label class="flex">Company Name<sup>*</sup></label>
                                          <mat-form-field appearance="outline">
                                              <input matInput formControlName="companyName">
                                          </mat-form-field>
                                          <div class="errorTxt">
                                              <div
                                                  *ngIf="companyProfileForm?.get('companyName')?.hasError('required') && companyProfileForm?.get('companyName')?.touched">
                                                  Company Name is required
                                              </div>
  
                                          </div>
                                      </div>
                                  </div> -->
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Company Address<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" matInput formControlName="companyAddress" />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div
                        *ngIf="
                          companyProfileForm?.get('companyAddress')?.hasError('required') &&
                          companyProfileForm?.get('companyAddress')?.touched
                        "
                      >
                        Company Address is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label>Country<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <mat-select formControlName="country" placeholder="Select Country" (selectionChange)="onChangeCountry()">
                        <mat-option value="">Select Country</mat-option>
                        <mat-option *ngFor="let data of countryData" [value]="data.id">{{ data.countryName }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="companyProfileForm?.get('country')?.hasError('required') && companyProfileForm?.get('country')?.touched">
                        Country is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <!-- <label>State<sup>*</sup></label>
                                          <mat-form-field appearance="outline">
                                              <mat-select formControlName="state" placeholder="Select State"
                                                  (selectionChange)="getCity();this.companyProfileForm.get('city')?.reset();">
                                                  <mat-option value="">Select State</mat-option>
                                                  <mat-option *ngFor="let data of stateData"
                                                      [value]="data.id">{{data.stateName}}</mat-option>
                                              </mat-select>
                                          </mat-form-field>
                                          <div class="errorTxt">
                                              <div
                                                  *ngIf="companyProfileForm?.get('state')?.hasError('required') && companyProfileForm?.get('state')?.touched">
                                                  State is required
                                              </div>
  
                                          </div> -->

                    <label class="flex">Zipcode<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input matInput maxlength="15" formControlName="pincode" placeholder="Enter Zipcode" (keyup)="searchSupplierZip()" />
                    </mat-form-field>
                    <div class="errorTxt" *ngIf="companyProfileForm?.get('pincode')?.touched || companyProfileForm?.get('pincode')?.dirty">
                      <div *ngIf="companyProfileForm?.get('pincode')?.hasError('required') && companyProfileForm?.get('pincode')?.touched">
                        Zipcode is required
                      </div>
                      <div
                        *ngIf="!companyProfileForm.value.country && !companyProfileForm?.get('pincode')?.hasError('required')"
                        [ngClass]="{
                          hide: companyProfileForm.value.pincode?.length === 0
                        }"
                      >
                        Please Select Country
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <!-- <label>City<sup>*</sup></label>
                                          <mat-form-field appearance="outline">
                                              <mat-select formControlName="city" placeholder="Select City">
                                                  <mat-option value="">Select City</mat-option>
                                                  <mat-option *ngFor="let data of cityData"
                                                      [value]="data.id">{{data.cityName}}</mat-option>
                                              </mat-select>
                                          </mat-form-field>
                                          <div class="errorTxt">
                                              <div
                                                  *ngIf="companyProfileForm?.get('city')?.hasError('required') && companyProfileForm?.get('city')?.touched">
                                                  City is required
                                              </div>
  
                                          </div> -->

                    <div *ngIf="showStateCitySelect">
                      <label>State <sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <mat-select formControlName="state" placeholder="Select state">
                          <mat-option value="">Select State</mat-option>
                          <mat-option *ngFor="let state of stateData" [value]="state.stateName">{{ state.stateName }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div *ngIf="!showStateCitySelect">
                      <label>State <sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input matInput maxlength="200" formControlName="state" placeholder="Select state" />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup" *ngIf="showStateCitySelect">
                    <label class="flex">City <sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <mat-select formControlName="city" placeholder="Select city">
                        <mat-option value="">Select City</mat-option>
                        <mat-option *ngFor="let data of cityData" [value]="data.cityName">{{ data.cityName }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="formGroup" *ngIf="!showStateCitySelect">
                    <label class="flex">City <sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input matInput maxlength="200" formControlName="city" placeholder="Select city" />
                    </mat-form-field>
                  </div>
                </div>
                <!-- <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Company Headquarter Address<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input matInput maxlength="200" formControlName="headquaterAddress" />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div
                          *ngIf="
                            companyProfileForm?.get('headquaterAddress')?.hasError('required') &&
                            companyProfileForm?.get('headquaterAddress')?.touched
                          "
                        >
                          Headquater Address is required
                        </div>
                      </div>
                    </div>
                  </div> -->
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Company Website</label>
                    <mat-form-field appearance="outline">
                      <input matInput maxlength="200" formControlName="websiteUrl" />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div
                        *ngIf="
                          companyProfileForm?.get('websiteUrl')?.hasError('required') && companyProfileForm?.get('websiteUrl')?.touched
                        "
                      >
                        Website URL is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Establishment Year<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <mat-select formControlName="establishmentYear" placeholder="Select Year">
                        <mat-option value="">Select Year</mat-option>
                        <mat-option *ngFor="let year of yearOptions" [value]="year">{{ year }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div
                        *ngIf="
                          companyProfileForm?.get('establishmentYear')?.hasError('required') &&
                          companyProfileForm?.get('establishmentYear')?.touched
                        "
                      >
                        Establishment year is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Expected Timeline<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <mat-select formControlName="timeline" placeholder="Select your timeline">
                        <mat-option selected="true">Select your timeline</mat-option>
                        <mat-option *ngFor="let data of timelineList" [value]="data.timelineName">{{ data.timelineName }} </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div
                        *ngIf="companyProfileForm?.get('timeline')?.hasError('required') && companyProfileForm?.get('timeline')?.touched"
                      >
                        Expected Timeline is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" *ngIf="companyProfileForm.get('timeline')?.value === 'others'">
                  <div class="formGroup">
                    <label class="flex">Expected Timeline For Others<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <!-- Use an input field for the Other timeline -->
                      <input matInput maxlength="200" formControlName="otherTimeline" placeholder="Enter other timeline" />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div
                        *ngIf="
                          companyProfileForm.get('timelineOther')?.hasError('required') && companyProfileForm.get('timelineOther')?.touched
                        "
                      >
                        Expected Timeline for Others is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="medium">Select Your Industry & Sector<sup>*</sup></label>
                    <div class="popupDropdown">
                      <div class="alignCenter flex" *ngIf="!industryData.length || industryData.length < 1">
                        <span class="iconCenter"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            (click)="openIndustryDialog()"
                            class="badge-notfication"
                            height="24"
                            viewBox="0 -960 960 960"
                            width="24"
                          >
                            <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
                          </svg>
                        </span>
                        <span class="placeholderText">Enter Your Industry & Sector</span>
                      </div>
                      <div class="chipIcon">
                        <ng-container *ngFor="let industryChip of industryData">
                          <mat-chip *ngIf="industryChip?.sectors?.length > 0">
                            {{ industryChip?.industryName }}
                            ({{ industryChip?.sectors?.length }})
                          </mat-chip>
                        </ng-container>
                      </div>
                      <div class="dialogEdit" *ngIf="industryData.length > 0" (click)="openIndustryDialog()">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" class="badge-notfication" width="24">
                          <path
                            d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="errorTxt">
                    <div *ngIf="industryData.length <= 0">Industry and sector is required.</div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="medium">Your Interest Area<sup>*</sup></label>
                    <div class="popupDropdown">
                      <div class="alignCenter flex" *ngIf="!interestData.length || interestData.length < 1">
                        <span class="iconCenter"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            (click)="openInterestDialog()"
                            class="badge-notfication"
                            height="24"
                            viewBox="0 -960 960 960"
                            width="24"
                          >
                            <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
                          </svg>
                        </span>

                        <span class="placeholderText">Enter Your Interest Area</span>
                      </div>
                      <div class="chipIcon">
                        <ng-container *ngFor="let interestChip of interestData">
                          <mat-chip *ngIf="interestChip.interestValues?.length > 0">
                            {{ interestChip.name }} ({{ interestChip.interestValues?.length }})
                          </mat-chip>
                        </ng-container>
                      </div>

                      <div class="dialogEdit" *ngIf="interestData.length > 0" (click)="openInterestDialog()">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" class="badge-notfication" width="24">
                          <path
                            d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="interestValidation" class="errorTxt">please select interest from all category</div>
                  <br />
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Company Contact<sup>*</sup></label>
                    <div class="mobileItem d-flex">
                      <ngx-intl-tel-input
                        [cssClass]="'custom'"
                        [preferredCountries]="preferredCountries"
                        [enableAutoCountrySelect]="true"
                        [enablePlaceholder]="true"
                        [searchCountryFlag]="true"
                        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                        [selectFirstCountry]="false"
                        [selectedCountryISO]="CountryISO.India"
                        [maxLength]="15"
                        [enablePlaceholder]="true"
                        customPlaceholder="Enter mobile number"
                        [phoneValidation]="true"
                        [separateDialCode]="separateDialCode"
                        [numberFormat]="PhoneNumberFormat.National"
                        formControlName="companyContact"
                      >
                      </ngx-intl-tel-input>
                    </div>
                    <div class="errorTxt">
                      <div *ngIf="companyProfileForm?.get('companyContact')?.touched || companyProfileForm?.get('companyContact')?.dirty">
                        {{ isPhoneValid(companyProfileForm.controls["companyContact"].errors) }}
                      </div>
                      <div *ngIf="companyProfileForm?.get('companyContact')?.touched">
                        {{ isPhoneRequired(companyProfileForm.value.companyContact) }}
                      </div>
                    </div>
                  </div>
                  <!-- <div class="formGroup">
                    <label class="flex">Company Contact<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input matInput maxlength="15" formControlName="companyContact" />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div
                        *ngIf="
                          companyProfileForm?.get('companyContact')?.hasError('required') &&
                          companyProfileForm?.get('companyContact')?.touched
                        "
                      >
                        Company Contact is required
                      </div>
                    </div>
                  </div> -->
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Is the company publicly listed?</label>
                    <div *ngIf="this.profileInfo1?.customerCompanyProfile?.isPublicated == true; else notListed">
                      <mat-slide-toggle [(ngModel)]="isChecked" formControlName="publicated"></mat-slide-toggle>
                    </div>
                    <ng-template #notListed>
                      <mat-slide-toggle [(ngModel)]="isChecked" formControlName="publicated"></mat-slide-toggle>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Type of development<sup>*</sup></label>
                    <div *ngIf="this.profileInfo1?.customerCompanyProfile?.isDevelopmentNew == true; else notNewDev">
                      <mat-radio-group formControlName="isDevelopmentNew">
                        <mat-radio-button value="1">New </mat-radio-button>
                        <mat-radio-button value="2">Existing</mat-radio-button>
                      </mat-radio-group>
                    </div>
                    <ng-template #notNewDev>
                      <mat-radio-group formControlName="isDevelopmentNew">
                        <mat-radio-button value="1">New </mat-radio-button>
                        <mat-radio-button value="2">Existing</mat-radio-button>
                      </mat-radio-group>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Company Profile</label>
                    <div *ngIf="!profileInfo1?.customerCompanyProfile?.brochureDoc?.fileName">
                      <lib-upload-file
                        (fileUploadEvent)="fileUploadEvent($event)"
                        [documentInfo]="documentInfo"
                        [fileUploadConfig]="fileUploadConfig"
                        [resetFileUpload]="resetFileUpload"
                      ></lib-upload-file>
                    </div>
                    <div *ngIf="profileInfo1?.customerCompanyProfile?.brochureDoc?.fileName">
                      <div class="file-upload-status flex alignCenter">
                        <div class="col-lg-6 col-md-12 col-sm-12 flex alignCenter">
                          <span
                            class="file-name"
                            matTooltip="{{ profileInfo1?.customerCompanyProfile?.brochureDoc?.fileName }}"
                            matTooltipPosition="left"
                          >
                            {{ profileInfo1?.customerCompanyProfile?.brochureDoc?.fileName }}</span
                          >
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12 file-upload-size-info flex alignCenter">
                          <span class="file-size"> {{ profileInfo1?.customerCompanyProfile?.brochureDoc?.size }}</span>
                          <span
                            (click)="
                              downloadBrochureFile(
                                profileInfo1?.customerCompanyProfile?.brochureDoc?.id,
                                profileInfo1?.customerCompanyProfile?.brochureDoc?.fileName
                              )
                            "
                          >
                            <mat-icon>save_alt</mat-icon>
                          </span>
                          <span (click)="deleteBrochureFileLocal()">
                            <mat-icon>delete_outline</mat-icon>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label>Turnover (Last Financial Year - in USD Million)<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <mat-select formControlName="turnover" placeholder="Select Turnover">
                        <mat-option selected="true">Select Turnover</mat-option>
                        <mat-option *ngFor="let data1 of turnOvers" [value]="data1.turnoverRange">
                          {{ data1.turnoverRange }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div
                        *ngIf="companyProfileForm?.get('turnover')?.hasError('required') && companyProfileForm?.get('turnover')?.touched"
                      >
                        Turnover is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label>Total Employee <sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <mat-select formControlName="companySize" placeholder="Select Total Employee">
                        <mat-option>Select Total Employee</mat-option>
                        <mat-option *ngFor="let data of companySizeData" [value]="data.companySizeName">
                          {{ data.companySizeName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div
                        *ngIf="
                          companyProfileForm?.get('companySize')?.hasError('required') && companyProfileForm?.get('companySize')?.touched
                        "
                      >
                        Total employee is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="formGroup">
                <mat-slide-toggle formControlName="isItHeadquarter" (change)="onToggleChange($event)"
                  >Headquarters is the same as above
                </mat-slide-toggle>
              </div>

              <form [formGroup]="headQuaterForm">
                <div class="formGroup" *ngIf="!isHeaquarterAdrressSame">
                  <label>Company Headquarters Address<sup>*</sup><small> (Max 200 characters) </small></label>
                  <mat-form-field appearance="outline">
                    <textarea
                      maxlength="200"
                      matInput
                      formControlName="headquarterAddress"
                      placeholder="Enter company headquarters address"
                    ></textarea>
                  </mat-form-field>
                </div>
                <div class="row" *ngIf="!isHeaquarterAdrressSame">
                  <div class="col-md-6">
                    <div class="formGroup">
                      <label>Country <sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <mat-select
                          id="modules_registration_module_registrationform_19"
                          formControlName="headquarterCountryId"
                          placeholder="Select Country"
                          (selectionChange)="onChangeCountryHeadQuarter()"
                        >
                          <mat-option value="">Select Country</mat-option>
                          <mat-option *ngFor="let country of countryData" [value]="country.id"
                            ><span>{{ country?.countryName }}</span></mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <!--  -->
                  <div class="col-md-6">
                    <div class="formGroup">
                      <label>Zipcode<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input
                          id="modules_registration_module_registrationform_20"
                          matInput
                          maxlength="15"
                          formControlName="headquarterPincode"
                          placeholder="Enter Zipcode"
                          (keyup)="searchSupplierZipHeadquarter()"
                        />
                      </mat-form-field>
                      <div
                        class="errorTxt"
                        *ngIf="headQuaterForm?.get('headquarterPincode')?.touched || headQuaterForm?.get('headquarterPincode')?.dirty"
                      >
                        <div *ngIf="headQuaterForm?.get('headquarterPincode')?.hasError('required')">zipcode is required</div>
                        <div
                          *ngIf="
                            !headQuaterForm.value.headquarterCountryId && !headQuaterForm?.get('headquarterPincode')?.hasError('required')
                          "
                          [ngClass]="{ hide: headQuaterForm.value.headquartersPincode?.length === 0 }"
                        >
                          Please Select Country
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" *ngIf="!isHeaquarterAdrressSame">
                  <div class="col-md-6">
                    <div class="formGroup">
                      <div *ngIf="showHStateCitySelect">
                        <label>State <sup>*</sup></label>
                        <mat-form-field appearance="outline">
                          <mat-select
                            id="modules_registration_module_registrationform_21"
                            formControlName="headquarterState"
                            placeholder="Select State"
                          >
                            <mat-option value="">Select state</mat-option>
                            <mat-option *ngFor="let state of headquarterstateData" [value]="[state.id, state.stateName]">{{
                              state.stateName
                            }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div *ngIf="!showHStateCitySelect">
                        <label>State <sup>*</sup></label>
                        <mat-form-field appearance="outline">
                          <input
                            id="modules_registration_module_registrationform_22"
                            matInput
                            maxlength="200"
                            formControlName="headquarterState"
                            placeholder="Enter State"
                          />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="formGroup">
                      <div *ngIf="showHStateCitySelect">
                        <label>City <sup>*</sup></label>
                        <mat-form-field appearance="outline">
                          <mat-select
                            id="modules_registration_module_registrationform_23"
                            formControlName="headquarterCity"
                            placeholder="Select city"
                          >
                            <mat-option value="">Select City</mat-option>
                            <mat-option *ngFor="let city of headquarterCityData" [value]="[city.id, city.cityName]">{{
                              city.cityName
                            }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div *ngIf="!showHStateCitySelect">
                        <label>City <sup>*</sup></label>
                        <mat-form-field appearance="outline">
                          <input
                            id="modules_registration_module_registrationform_24"
                            matInput
                            maxlength="200"
                            formControlName="headquarterCity"
                            placeholder="Enter city"
                          />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <!-- <form [formGroup]="headQuaterForm">
                  <div class="formGroup" *ngIf="!isHeaquarterAdrressSame">
                    <label>Company Headquarters<sup>*</sup><small> (Max 200 characters) </small></label>
                    <mat-form-field appearance="outline">
                      <textarea
                        maxlength="200"
                        matInput
                        formControlName="headquartersAddress"
                        placeholder="Enter company headquarters"
                      ></textarea>
                    </mat-form-field>
                  </div>
                  <div class="row" *ngIf="!isHeaquarterAdrressSame">
                    <div class="col-md-6">
                      <div class="formGroup">
                        <label>Country <sup>*</sup></label>
                        <mat-form-field appearance="outline">
                          <mat-select
                            id="modules_registration_module_registrationform_19"
                            formControlName="headquartersCountry"
                            placeholder="Select Country"
                            (selectionChange)="onChangeCountryHeadQuarter()"
                          >
                            <mat-option value="">Select Country</mat-option>
                            <mat-option *ngFor="let country of countryData" [value]="[country.id, country.countryName]"
                              ><span>{{ country?.countryName }}</span></mat-option
                            >
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="formGroup">
                      
  
                        <label>Zipcode<sup>*</sup></label>
                        <mat-form-field appearance="outline">
                          <input
                            id="modules_registration_module_registrationform_20"
                            matInput
                            maxlength="15"
                            formControlName="headquartersPincode"
                            placeholder="Enter Zipcode"
                            (keyup)="searchSupplierZipHeadquarter()"
                          />
                        </mat-form-field>
                        <div
                          class="errorTxt"
                          *ngIf="headQuaterForm?.get('headquartersPincode')?.touched || headQuaterForm?.get('headquartersPincode')?.dirty"
                        >
                          <div *ngIf="headQuaterForm?.get('headquartersPincode')?.hasError('required')">zipcode is required</div>
                          <div
                            *ngIf="
                              !headQuaterForm.value.headquartersCountry &&
                              !headQuaterForm?.get('headquartersPincode')?.hasError('required')
                            "
                            [ngClass]="{ hide: headQuaterForm.value.headquartersPincode?.length === 0 }"
                          >
                            Please Select Country
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="!isHeaquarterAdrressSame">
                    <div class="col-md-6">
                      <div class="formGroup">
                
                        <div *ngIf="showHStateCitySelect">
                          <label>State <sup>*</sup></label>
                          <mat-form-field appearance="outline">
                            <mat-select
                              id="modules_registration_module_registrationform_21"
                              formControlName="headquartersState"
                              placeholder="Select State"
                            >
                              <mat-option value="">Select state</mat-option>
                              <mat-option *ngFor="let state of headquarterstateData" [value]="[state.id, state.stateName]">{{
                                state.stateName
                              }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div *ngIf="!showHStateCitySelect">
                          <label>State <sup>*</sup></label>
                          <mat-form-field appearance="outline">
                            <input
                              id="modules_registration_module_registrationform_22"
                              matInput
                              maxlength="200"
                              formControlName="headquartersState"
                              placeholder="Enter State"
                            />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="formGroup">
                      
                        <div *ngIf="showHStateCitySelect">
                          <label>City <sup>*</sup></label>
                          <mat-form-field appearance="outline">
                            <mat-select
                              id="modules_registration_module_registrationform_23"
                              formControlName="headquartersCity"
                              placeholder="Select city"
                            >
                              <mat-option value="">Select City</mat-option>
                              <mat-option *ngFor="let city of headquarterCityData" [value]="[city.id, city.cityName]">{{
                                city.cityName
                              }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div *ngIf="!showHStateCitySelect">
                          <label>City <sup>*</sup></label>
                          <mat-form-field appearance="outline">
                            <input
                              id="modules_registration_module_registrationform_24"
                              matInput
                              maxlength="200"
                              formControlName="headquartersCity"
                              placeholder="Enter city"
                            />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </form> -->
            </div>

            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-12">
                <lucide-icon name="MapPin" class="user_icon"></lucide-icon>
                Manufacturing Locations
              </h4>
              <div [formGroup]="regionSelectionForm">
                <div class="container region-selection-dropdown-wrapper">
                  <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      <div class="formGroup">
                        <label>
                          <h4 class="font-14">Add Region</h4>
                        </label>
                        <mat-form-field appearance="outline">
                          <mat-select #regionSelect formControlName="selectedRegion" multiple>
                            <mat-option
                              (onSelectionChange)="addedRegion($event)"
                              *ngFor="let regionList of regionsList"
                              [value]="regionList.regionWisePresenceId"
                            >
                              {{ regionList.regionWisePresenceName }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-5 col-md-6 col-sm-6"></div>
                    <div class="col-lg-3 col-md-6 col-sm-6 flex alignCenter justify-content-end"></div>
                  </div>
                </div>
              </div>
              <div class="container">
                <form [formGroup]="regionsForm" (ngSubmit)="onSubmit()">
                  <div formArrayName="regions">
                    <mat-accordion>
                      <div class="accordian-panel" *ngFor="let region of regions().controls; let regionIndex = index">
                        <div [formGroupName]="regionIndex">
                          <mat-expansion-panel [expanded]="0">
                            <mat-expansion-panel-header class="expansion-panel-header">
                              <div class="row alignCenter">
                                <div class="col-lg-10 col-md-12 col-sm-12">
                                  <div class="expansion-panel-title">
                                    {{ getRegionName(region) }}
                                  </div>
                                </div>
                                <div class="col-lg-2 col-md-12 col-sm-12 flex justify-content-center">
                                  <div class="expansion-panel-delete-button">
                                    <button mat-raised-button (click)="removeRegion(regionIndex)">Remove Region</button>
                                  </div>
                                </div>
                              </div>
                            </mat-expansion-panel-header>
                            <div formArrayName="countries" class="expansion-panel-body">
                              <div *ngFor="let country of regionCountries(regionIndex).controls; let countryIndex = index">
                                <div class="container country-container" [formGroupName]="countryIndex">
                                  <div class="row">
                                    <div class="col-lg-3 col-md-6 col-sm-6">
                                      <div class="formGroup">
                                        <!-- <p>{{countryIndex}}</p> -->
                                        <label>Country</label>
                                        <mat-form-field appearance="outline">
                                          <mat-select formControlName="countryId">
                                            <mat-option
                                              *ngFor="let country of getRegionWiseCountries(region)"
                                              [value]="country.id"
                                              [disabled]="disabledCountries(regionIndex, country.id)"
                                            >
                                              {{ country.countryName }}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                    </div>

                                    <div class="col-lg-3 col-md-6 col-sm-6">
                                      <div class="formGroup">
                                        <label>Employees</label>
                                        <mat-form-field appearance="outline">
                                          <mat-select formControlName="companySizeId">
                                            <mat-option *ngFor="let manPower of manPowerList" [value]="manPower.companySizeId">
                                              {{ manPower.companySizeName }}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                    </div>

                                    <div class="col-lg-3 col-md-6 col-sm-6">
                                      <div class="formGroup">
                                        <label>Revenue (in USD Million) </label>
                                        <mat-form-field appearance="outline">
                                          <mat-select formControlName="turnoverId">
                                            <mat-option *ngFor="let revenue of revenueList" [value]="revenue.turnoverId">
                                              {{ revenue.turnoverRange }}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12 flex alignCenter justify-content-end">
                                      <button
                                        mat-raised-button
                                        (click)="removeRegionCountry(regionIndex, countryIndex)"
                                        [disabled]="disabledRemoveCountry(region, regionIndex)"
                                      >
                                        Remove Country
                                      </button>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                      <div class="formGroup">
                                        <label>Categories</label>
                                        <mat-form-field appearance="outline">
                                          <mat-select formControlName="categories" multiple>
                                            <mat-option *ngFor="let category of categoriesList" [value]="category.id">
                                              {{ category.categoryName }}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <button
                                mat-raised-button
                                color="warn"
                                type="submit"
                                (click)="addRegionCountry(regionIndex)"
                                [disabled]="disabledAddCountries(region, regionIndex)"
                              >
                                Add Country
                              </button>
                            </div>
                          </mat-expansion-panel>
                        </div>
                      </div>
                    </mat-accordion>
                  </div>
                </form>
              </div>
            </div>
          </form>
        </div>
      </mat-tab>

      <mat-tab label="KYC" *ngIf="kycTabShow && kycData?.status !== KYCStatus.APPROVED">
        <div class="tabInner">
          <form [formGroup]="KYCForm">
            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-12">
                <lucide-icon name="UserRoundCheck" class="user_icon"></lucide-icon>
                KYC Details
                <span class="accordianButton" [ngClass]="activeIndex == 1 ? 'active' : ''" (click)="toggleAccordion(1)">
                  <lucide-icon name="chevron-down" [size]="16" class="lucid-icon-arrow"></lucide-icon>
                </span>
              </h4>
              <div class="accordion-content" [ngClass]="activeIndex == 1 ? 'active' : ''">
                <div class="row">
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Company Name<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="companyName" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('companyName')?.hasError('required') && KYCForm?.get('companyName')?.touched">
                          Company Name is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Full legal name of the Company/Entity<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="legalName" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('legalName')?.hasError('required') && KYCForm?.get('legalName')?.touched">
                          Full legal name of the Company/Entity is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Authorised Person Name<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="regCompAuthPerson" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('regCompAuthPerson')?.hasError('required') && KYCForm?.get('regCompAuthPerson')?.touched">
                          Authorised Person Name is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Designation<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="regCompDesignation" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div
                          *ngIf="KYCForm?.get('regCompDesignation')?.hasError('required') && KYCForm?.get('regCompDesignation')?.touched"
                        >
                          Designation is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Category Of Business<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <mat-select placeholder="Select" formControlName="categoryOfBusiness">
                          <mat-option value="" [disabled]="true">Select Category Of Business</mat-option>
                          <mat-option *ngFor="let category of categoryOfBusiness" [value]="category.name">{{ category.name }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div class="errorTxt">
                        <div
                          *ngIf="KYCForm?.get('categoryOfBusiness')?.hasError('required') && KYCForm?.get('categoryOfBusiness')?.touched"
                        >
                          Category Of Business is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3" *ngIf="showBusinessOthers">
                    <div class="formGroup">
                      <label class="flex">Category of Business Others<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="businessOthers" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('businessOthers')?.hasError('required') && KYCForm?.get('businessOthers')?.touched">
                          Category of Business Others is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Country<sup>*</sup></label>
                        <mat-form-field appearance="outline">
                          <mat-select placeholder="Select" formControlName="country"  (selectionChange)="countryChanged($event)">
                            <mat-option value="" [disabled]="true">Select Country</mat-option>
                            <mat-option *ngFor="let country of cinCountryData" [value]="country?.countryName"
                            ><span>{{ country?.countryName }}</span></mat-option
                            >
                          </mat-select>
                        </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('country')?.hasError('required') && KYCForm?.get('country')?.touched">
                          Country type is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">CIN Type<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="cinType"  matInput [readonly]="isCinReadonly" />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('cinType')?.hasError('required') && KYCForm?.get('cinType')?.touched">
                          CIN type is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">CIN Number<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="cinNumber" (keydown)="blockInvalidChar($event)" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('cinNumber')?.hasError('required') && KYCForm?.get('cinNumber')?.touched">
                          CIN Number is required
                        </div>
                      </div>
                    </div>
                  </div>
                 
                 
                </div>
                <h4 class="itemTitle flex alignCenter font-12 uploadLabel">
                  <lucide-icon
                    name="file-text"
                    [size]="16"
                    class="lucid-icon-upload"
                    matTooltip="Text Here"
                    matTooltipPosition="left"
                  ></lucide-icon>
                  Upload Documents
                </h4>
                <div class="row alignBaselign kycUpload">
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex"
                        >Identification documents of authorised signatories/directors/owners
                        <sup>*</sup>
                        <lucide-icon
                          name="circle-help"
                          [size]="16"
                          class="lucid-icon-help"
                          matTooltip="Text Here"
                          matTooltipPosition="left"
                        ></lucide-icon>
                      </label>
                      <div *ngIf="!getFileExist(kycFilesKey.KD_AUTHRISE_ID)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.KD_AUTHRISE_ID)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>
                      <div *ngIf="getFileExist(kycFilesKey.KD_AUTHRISE_ID)">
                        <ng-container *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.KD_AUTHRISE_ID }"></ng-container>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex"
                        >For sole proprietors or individuals: Identification documents of the owner
                        <sup>*</sup>
                        <lucide-icon
                          name="circle-help"
                          [size]="16"
                          class="lucid-icon-help"
                          matTooltip="Text Here"
                          matTooltipPosition="left"
                        ></lucide-icon>
                      </label>
                      <div *ngIf="!getFileExist(kycFilesKey.KD_OWNER_ID)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.KD_OWNER_ID)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>
                      <div *ngIf="getFileExist(kycFilesKey.KD_OWNER_ID)">
                        <ng-container *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.KD_OWNER_ID }"></ng-container>
                      </div>
                    </div>
                  </div> -->
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex"
                        >GSTN/ Tax Registration Certificates
                        <sup>*</sup>
                        <lucide-icon
                          name="circle-help"
                          [size]="16"
                          class="lucid-icon-help"
                          matTooltip="Text Here"
                          matTooltipPosition="left"
                        ></lucide-icon>
                      </label>
                      <div *ngIf="!getFileExist(kycFilesKey.KD_TAX_CERTIFICATION)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.KD_TAX_CERTIFICATION)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>
                      <div *ngIf="getFileExist(kycFilesKey.KD_TAX_CERTIFICATION)">
                        <ng-container *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.KD_TAX_CERTIFICATION }"></ng-container>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Business License or Permits (if applicable)</label>
                      <div *ngIf="!getFileExist(kycFilesKey.KD_PERMITS)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.KD_PERMITS)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>
                      <div *ngIf="getFileExist(kycFilesKey.KD_PERMITS)">
                        <ng-container *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.KD_PERMITS }"></ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-12">
                <lucide-icon name="MapPin" class="user_icon"></lucide-icon>
                Registered Address
                <span class="accordianButton" [ngClass]="activeIndex == 2 ? 'active' : ''" (click)="toggleAccordion(2)">
                  <lucide-icon name="chevron-down" [size]="16" class="lucid-icon-arrow"></lucide-icon>
                </span>
              </h4>
              <div class="accordion-content" [ngClass]="activeIndex == 2 ? 'active' : ''">
                <div class="row">
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Company Name<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="regCompName" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('regCompName')?.hasError('required') && KYCForm?.get('regCompName')?.touched">
                          Company Address is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Address Line 1<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="regBuilding" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('regBuilding')?.hasError('required') && KYCForm?.get('regBuilding')?.touched">
                          Address is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Address Line 2<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="regCompStreet" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('regCompStreet')?.hasError('required') && KYCForm?.get('regCompStreet')?.touched">
                          Address is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Zipcode<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="15" formControlName="regCompPincode" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('regCompPincode')?.hasError('required') && KYCForm?.get('regCompPincode')?.touched">
                          Zipcode is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Country<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <mat-select placeholder="Select Country" formControlName="regCompCountry">
                          <mat-option value="" [disabled]="true">Select Country</mat-option>
                          <mat-option *ngFor="let country of countryData" [value]="country?.countryName"
                            ><span>{{ country?.countryName }}</span></mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('regCompCountry')?.hasError('required') && KYCForm?.get('regCompCountry')?.touched">
                          Country is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Email<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="regCompEmail" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('regCompEmail')?.hasError('required') && KYCForm?.get('regCompEmail')?.touched">
                          Email is required
                        </div>
                        <div
                          *ngIf="
                            KYCForm?.get('regCompEmail')?.value != '' &&
                            (KYCForm?.get('regCompEmail')?.hasError('email') || KYCForm.get('regCompEmail')?.hasError('numericAfterDotCom'))
                          "
                        >
                          Must be a valid email address
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Mobile No.<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="15" formControlName="regCompMobile" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('regCompMobile')?.hasError('required') && KYCForm?.get('regCompMobile')?.touched">
                          Mobile No. is required
                        </div>
                        <div *ngIf="KYCForm?.get('regCompMobile')?.value != '' && KYCForm?.get('regCompMobile')?.hasError('pattern')">
                          Must be a valid number
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Office Telephone No.</label>
                      <mat-form-field appearance="outline">
                        <input maxlength="15" formControlName="regCompTelephone" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div
                          *ngIf="
                            KYCForm?.get('regCompTelephone')?.value != '' &&
                            (KYCForm?.get('regCompTelephone')?.hasError('pattern') ||
                              KYCForm?.get('regCompTelephone')?.hasError('minlength') ||
                              KYCForm?.get('regCompTelephone')?.hasError('maxlength'))
                          "
                        >
                          Must be a valid number
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h4 class="itemTitle flex alignCenter font-12 uploadLabel">
                  <lucide-icon
                    name="file-text"
                    [size]="16"
                    class="lucid-icon-upload"
                    matTooltip="Text Here"
                    matTooltipPosition="left"
                  ></lucide-icon>
                  Upload Documents
                </h4>
                <div class="row alignBaselign kycUpload">
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Certificate of Incorporation/Business Registration Certificate<sup>*</sup></label>
                      <div *ngIf="!getFileExist(kycFilesKey.RA_REGISTRATION_CERTIFICATES)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.RA_REGISTRATION_CERTIFICATES)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>

                      <div *ngIf="getFileExist(kycFilesKey.RA_REGISTRATION_CERTIFICATES)">
                        <ng-container
                          *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.RA_REGISTRATION_CERTIFICATES }"
                        ></ng-container>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Recent utility bills</label>
                      <div *ngIf="!getFileExist(kycFilesKey.RA_UTILITY_BILLS)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.RA_UTILITY_BILLS)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>

                      <div *ngIf="getFileExist(kycFilesKey.RA_UTILITY_BILLS)">
                        <ng-container *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.RA_UTILITY_BILLS }"></ng-container>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Lease agreement or property ownership docs</label>
                      <div *ngIf="!getFileExist(kycFilesKey.RA_OWNERSHIP_DOC)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.RA_OWNERSHIP_DOC)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>
                      <div *ngIf="getFileExist(kycFilesKey.RA_OWNERSHIP_DOC)">
                        <ng-container *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.RA_OWNERSHIP_DOC }"></ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-12">
                <lucide-icon name="MapPin" class="user_icon"></lucide-icon>
                Correspondence Address
                <span class="accordianButton" [ngClass]="activeIndex == 3 ? 'active' : ''" (click)="toggleAccordion(3)">
                  <lucide-icon name="chevron-down" [size]="16" class="lucid-icon-arrow"></lucide-icon>
                </span>
              </h4>
              <div class="flex registered_form" *ngIf="activeIndex == 3">
                <input type="checkbox" (click)="correspondSameasreg($event)" /> Same as registered address
              </div>
              <div class="accordion-content" [ngClass]="activeIndex == 3 ? 'active' : ''">
                <div class="row">
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Company Name<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="corCompName" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('corCompName')?.hasError('required') && KYCForm?.get('corCompName')?.touched">
                          Company Name is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Address Line 1<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="corBuilding" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('corBuilding')?.hasError('required') && KYCForm?.get('corBuilding')?.touched">
                          Address is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Address Line 2<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="corCompStreet" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('corCompStreet')?.hasError('required') && KYCForm?.get('corCompStreet')?.touched">
                          Address is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">ZipCode<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="15" formControlName="corCompPincode" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('corCompPincode')?.hasError('required') && KYCForm?.get('corCompPincode')?.touched">
                          Zipcode is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Country<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <mat-select placeholder="Select Country" formControlName="corCompCountry">
                          <mat-option value="" [disabled]="true">Select Country</mat-option>
                          <mat-option *ngFor="let country of countryData" [value]="country?.countryName"
                            ><span>{{ country?.countryName }}</span></mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('corCompCountry')?.hasError('required') && KYCForm?.get('corCompCountry')?.touched">
                          Country is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Authorised Person Name<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="corCompAuthorizedPerson" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div
                        *ngIf="
                          KYCForm?.get('corCompAuthorizedPerson')?.hasError('required') && KYCForm?.get('corCompAuthorizedPerson')?.touched
                        "
                      >
                        Authorised Person Name is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Designation<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="corCompDesignation" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('corCompDesignation')?.hasError('required') && KYCForm?.get('corCompDesignation')?.touched">
                        Designation is required
                      </div>
                    </div>
                  </div>
                </div> -->
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Email <sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="corCompEmail" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('corCompEmail')?.hasError('required') && KYCForm?.get('corCompEmail')?.touched">
                          Email is required
                        </div>
                        <div
                          *ngIf="
                            KYCForm?.get('corCompEmail')?.value != '' &&
                            (KYCForm?.get('corCompEmail')?.hasError('email') || KYCForm.get('corCompEmail')?.hasError('numericAfterDotCom'))
                          "
                        >
                          Must be a valid email address
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Mobile No.<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="15" formControlName="corCompMobile" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('corCompMobile')?.hasError('required') && KYCForm?.get('corCompMobile')?.touched">
                          Mobile No. is required
                        </div>
                        <div *ngIf="KYCForm?.get('corCompMobile')?.value != '' && KYCForm?.get('corCompMobile')?.hasError('pattern')">
                          Must be a valid number
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Office Telephone No.</label>
                      <mat-form-field appearance="outline">
                        <input maxlength="15" formControlName="corCompTelephone" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <!-- <div *ngIf="KYCForm?.get('corCompTelephone')?.hasError('required') && KYCForm?.get('corCompTelephone')?.touched">
                        Office Telephone No. is required
                      </div> -->
                        <div
                          *ngIf="
                            KYCForm?.get('corCompTelephone')?.value != '' &&
                            (KYCForm?.get('corCompTelephone')?.hasError('pattern') ||
                              KYCForm?.get('corCompTelephone')?.hasError('minlength') ||
                              KYCForm?.get('corCompTelephone')?.hasError('maxlength'))
                          "
                        >
                          Must be a valid number
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h4 class="itemTitle flex alignCenter font-12 uploadLabel" *ngIf="!isSameAsAddress">
                  <lucide-icon
                    name="file-text"
                    [size]="16"
                    class="lucid-icon-upload"
                    matTooltip="Text Here"
                    matTooltipPosition="left"
                  ></lucide-icon>
                  Upload Documents
                </h4>
                <div class="row alignBaselign kycUpload" *ngIf="!isSameAsAddress">
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Certificate of Incorporation/Business Registration Certificate<sup>*</sup></label>
                      <div *ngIf="!getFileExist(kycFilesKey.CA_REGISTRATION_CERTIFICATES)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.CA_REGISTRATION_CERTIFICATES)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>
                      <div *ngIf="getFileExist(kycFilesKey.CA_REGISTRATION_CERTIFICATES)">
                        <ng-container
                          *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.CA_REGISTRATION_CERTIFICATES }"
                        ></ng-container>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Recent utility bills</label>
                      <div *ngIf="!getFileExist(kycFilesKey.CA_UTILITY_BILLS)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.CA_UTILITY_BILLS)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>
                      <div *ngIf="getFileExist(kycFilesKey.CA_UTILITY_BILLS)">
                        <ng-container *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.CA_UTILITY_BILLS }"></ng-container>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Lease agreement or property ownership docs</label>
                      <div *ngIf="!getFileExist(kycFilesKey.CA_OWNERSHIP_DOC)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.CA_OWNERSHIP_DOC)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>
                      <div *ngIf="getFileExist(kycFilesKey.CA_OWNERSHIP_DOC)">
                        <ng-container *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.CA_OWNERSHIP_DOC }"></ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-12">
                <lucide-icon name="Landmark" class="user_icon"></lucide-icon>
                Finance & Bank Details
                <span class="accordianButton" [ngClass]="activeIndex == 4 ? 'active' : ''" (click)="toggleAccordion(4)">
                  <lucide-icon name="chevron-down" [size]="16" class="lucid-icon-arrow"></lucide-icon>
                </span>
              </h4>
              <div class="accordion-content" [ngClass]="activeIndex == 4 ? 'active' : ''">
                <div class="row alignBaselign kycUpload">
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Tax Number Type<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <mat-select placeholder="Select " formControlName="taxType">
                          <mat-option value="" [disabled]="true">Select Tax Number Type</mat-option>
                          <mat-option *ngFor="let number of taxNumberData" [value]="number.name">{{ number.name }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('taxType')?.hasError('required') && KYCForm?.get('taxType')?.touched">
                          Tax Number Type is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Tax Number<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="taxNumber" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('taxNumber')?.hasError('required') && KYCForm?.get('taxNumber')?.touched">
                          Tax Number is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Legal Status of the Company<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <mat-select placeholder="Select" formControlName="legalStatus">
                          <mat-option value="" [disabled]="true">Select Legal Status</mat-option>
                          <mat-option *ngFor="let status of legalStatus" [value]="status.name">{{ status.name }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('legalStatus')?.hasError('required') && KYCForm?.get('legalStatus')?.touched">
                          Legal Status of the Company is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Bank Name<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="bankName" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('bankName')?.hasError('required') && KYCForm?.get('bankName')?.touched">
                          Bank Name is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Account Number<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="accountNumber" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('accountNumber')?.hasError('required') && KYCForm?.get('accountNumber')?.touched">
                          Account Number is required
                        </div>
                        <div *ngIf="KYCForm?.get('accountNumber')?.value != '' && KYCForm?.get('accountNumber')?.hasError('pattern')">
                          Must be a valid number
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">IBAN Number<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="ibanNumber" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('ibanNumber')?.hasError('required') && KYCForm?.get('ibanNumber')?.touched">
                          IBAN Number is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">SWIFT Code/ IFSC Code<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="swiftCode" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('swiftCode')?.hasError('required') && KYCForm?.get('swiftCode')?.touched">
                          SWIFT Code/ IFSC Code is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Bank Address<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="bankAddress" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('bankAddress')?.hasError('required') && KYCForm?.get('bankAddress')?.touched">
                          Bank Address is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Name of the firm as per bank records<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" formControlName="nameAsPerRecord" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('nameAsPerRecord')?.hasError('required') && KYCForm?.get('nameAsPerRecord')?.touched">
                          Name of the firm as per bank records is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Cancelled Cheque Copy<sup>*</sup></label>
                      <div *ngIf="!getFileExist(kycFilesKey.CANCEL_CHEQUE)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.CANCEL_CHEQUE)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>
                      <div *ngIf="getFileExist(kycFilesKey.CANCEL_CHEQUE)">
                        <ng-container *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.CANCEL_CHEQUE }"></ng-container>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Cancelled Cheque Copy<sup>*</sup></label>
                      <input
                        type="file"
                        formControlName="cancelledCheque"
                        #cancelledChequeFileSelector
                        (change)="getCancelledCheque($event)"
                      />
                      <div class="errorTxt">
                        <div
                          *ngIf="
                            KYCForm?.get('cancelledCheque')?.hasError('required') &&
                            KYCForm?.get('cancelledCheque')?.touched &&
                            !kycData?.kycAttachment
                          "
                        >
                          Cancelled Cheque Copy is required
                        </div>
                      </div>
                      <div class="flex file-upload-status alignCenter" *ngIf="cancelledCheque">
                        <div class="col-lg-7 col-md-12 col-sm-12 flex alignCenter">
                          <span class="file-name" matTooltip="{{ cancelledCheque.name }}" matTooltipPosition="left">
                            {{ cancelledCheque.name }}</span
                          >
                        </div>
                        <div>
                          {{ formatBytes(cancelledCheque.size) }}
                        </div>
                        <mat-icon (click)="deleteAttachedFile()">delete</mat-icon>
                        <mat-icon (click)="downloadAttachedFile()">save_alt</mat-icon>
                      </div>
                      <div class="file-upload-status flex alignCenter" *ngIf="!cancelledCheque && kycData?.kycAttachment?.fileName">
                        <div class="col-lg-7 col-md-12 col-sm-12 flex alignCenter">
                          <span class="file-name" matTooltip="{{ kycData?.kycAttachment?.fileName }}" matTooltipPosition="left">
                            {{ kycData?.kycAttachment?.fileName }}</span
                          >
                        </div>
                        <div class="col-lg-5 col-md-12 col-sm-12 file-upload-size-info flex alignCenter">
                          <span class="file-size"> {{ kycData?.kycAttachment?.size }}</span>
                          <span (click)="deleteAttachedFile()">
                            <mat-icon>delete</mat-icon>
                          </span>
                          <span (click)="downloadKycFile(kycData?.kycAttachment?.id, kycData?.kycAttachment?.fileName)">
                            <mat-icon>save_alt</mat-icon>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
                <label class="flex">Annual Turnover (last 3 years, in USD)</label>
                <div class="row">
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Year<sup>*</sup></label>
                      <mat-form-field appearance="outline" class="disable">
                        <mat-select placeholder="Select" formControlName="yearOne">
                          <mat-option value="">Select</mat-option>
                          <mat-option *ngFor="let year of lastThreeYears" [value]="year">{{ year }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('yearOne')?.hasError('required') && KYCForm?.get('yearOne')?.touched">
                          Year is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Amount<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" type="number" formControlName="yearOneRevenue" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('yearOneRevenue')?.hasError('required') && KYCForm?.get('yearOneRevenue')?.touched">
                          Amount is required
                        </div>
                        <div *ngIf="KYCForm?.get('yearOneRevenue')?.hasError('pattern') && KYCForm?.get('yearOneRevenue')?.touched">
                          Must be a valid amount
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Year<sup>*</sup></label>
                      <mat-form-field appearance="outline" class="disable">
                        <mat-select placeholder="Select Year" formControlName="yearTwo">
                          <mat-option value="">Select</mat-option>
                          <mat-option *ngFor="let year of lastThreeYears" [value]="year">{{ year }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('yearTwo')?.hasError('required') && KYCForm?.get('yearTwo')?.touched">
                          Year is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Amount<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" type="number" formControlName="yearTwoRevenue" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('yearTwoRevenue')?.hasError('required') && KYCForm?.get('yearTwoRevenue')?.touched">
                          Amount is required
                        </div>
                        <div *ngIf="KYCForm?.get('yearTwoRevenue')?.hasError('pattern') && KYCForm?.get('yearTwoRevenue')?.touched">
                          Must be a valid amount
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Year<sup>*</sup></label>
                      <mat-form-field appearance="outline" class="disable">
                        <mat-select placeholder="Select Year" formControlName="yearThree">
                          <mat-option value="">Select</mat-option>
                          <mat-option *ngFor="let year of lastThreeYears" [value]="year">{{ year }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('yearThree')?.hasError('required') && KYCForm?.get('yearThree')?.touched">
                          Year is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Amount<sup>*</sup></label>
                      <mat-form-field appearance="outline">
                        <input maxlength="200" type="number" formControlName="yearThreeRevenue" matInput />
                      </mat-form-field>
                      <div class="errorTxt">
                        <div *ngIf="KYCForm?.get('yearThreeRevenue')?.hasError('required') && KYCForm?.get('yearThreeRevenue')?.touched">
                          Amount is required
                        </div>
                        <div *ngIf="KYCForm?.get('yearThreeRevenue')?.hasError('pattern') && KYCForm?.get('yearThreeRevenue')?.touched">
                          Must be a valid amount
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h4 class="itemTitle flex alignCenter font-12 uploadLabel">
                  <lucide-icon
                    name="file-text"
                    [size]="16"
                    class="lucid-icon-upload"
                    matTooltip="Text Here"
                    matTooltipPosition="left"
                  ></lucide-icon>
                  Upload Documents
                </h4>
                <div class="row alignBaselign kycUpload">
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex"
                        >Bank statements or proof of banking relationship for last 1 year (signed by bank)<sup>*</sup></label
                      >
                      <div *ngIf="!getFileExist(kycFilesKey.FB_BANK_STATEMENT)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.FB_BANK_STATEMENT)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>
                      <div *ngIf="getFileExist(kycFilesKey.FB_BANK_STATEMENT)">
                        <ng-container *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.FB_BANK_STATEMENT }"></ng-container>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Financial statements (balance sheets, profit and loss statements) for the last 1 year</label>
                      <div *ngIf="!getFileExist(kycFilesKey.FB_FINANCIAL_STATEMENT)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.FB_FINANCIAL_STATEMENT)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>
                      <div *ngIf="getFileExist(kycFilesKey.FB_FINANCIAL_STATEMENT)">
                        <ng-container
                          *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.FB_FINANCIAL_STATEMENT }"
                        ></ng-container>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Tax returns for the last 1 year</label>
                      <div *ngIf="!getFileExist(kycFilesKey.FB_TAX_RETURN)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.FB_TAX_RETURN)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>
                      <div *ngIf="getFileExist(kycFilesKey.FB_TAX_RETURN)">
                        <ng-container *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.FB_TAX_RETURN }"></ng-container>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">General liability insurance certificates</label>
                      <div *ngIf="!getFileExist(kycFilesKey.FB_GENERAL_LIABILITY)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.FB_GENERAL_LIABILITY)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>
                      <div *ngIf="getFileExist(kycFilesKey.FB_GENERAL_LIABILITY)">
                        <ng-container *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.FB_GENERAL_LIABILITY }"></ng-container>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="formGroup">
                      <label class="flex">Product liability insurance certificates (if applicable)</label>
                      <div *ngIf="!getFileExist(kycFilesKey.FB_PRODUCT_LIABILITY)">
                        <app-upload-dnd
                          (fileUploadEvent)="fileUploadEventKyc($event, kycFilesKey.FB_PRODUCT_LIABILITY)"
                          [documentInfo]="documentInfoKyc"
                          [fileUploadConfig]="fileUploadConfigKyc"
                          [resetFileUpload]="resetFileUpload"
                          [showDragDrop]="false"
                        ></app-upload-dnd>
                      </div>

                      <div *ngIf="getFileExist(kycFilesKey.FB_PRODUCT_LIABILITY)">
                        <ng-container *ngTemplateOutlet="fileList; context: { $implicit: kycFilesKey.FB_PRODUCT_LIABILITY }"></ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </mat-tab>
      <mat-tab label="Finances" *ngIf="financeTab">
        <div class="tabInner">
          <form [formGroup]="financeProfileForm">
            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-12">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M2.33301 11.3332V6.6665H3.66634V11.3332H2.33301ZM6.33301 11.3332V6.6665H7.66634V11.3332H6.33301ZM0.333008 13.9998V12.6665H13.6663V13.9998H0.333008ZM10.333 11.3332V6.6665H11.6663V11.3332H10.333ZM0.333008 5.33317V3.99984L6.99967 0.666504L13.6663 3.99984V5.33317H0.333008ZM3.29967 3.99984H10.6997L6.99967 2.1665L3.29967 3.99984Z"
                    fill="#E14D54"
                  />
                </svg>
                Bank Details
              </h4>
              <div class="row">
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Company Name<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="companyName" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('companyName')?.hasError('required') && KYCForm?.get('companyName')?.touched">
                        Company Name is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Full legal name of the Company/Entity<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="legalName" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('legalName')?.hasError('required') && KYCForm?.get('legalName')?.touched">
                        Full legal name of the Company/Entity is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">CIN Type<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <mat-select placeholder="Select" formControlName="cinType">
                        <mat-option value="" [disabled]="true">Select CIN Type</mat-option>
                        <mat-option *ngFor="let cin of cinData" [value]="cin.name">{{ cin.name }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('cinType')?.hasError('required') && KYCForm?.get('cinType')?.touched">
                        CIN type is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">CIN Number<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="cinNumber" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('cinNumber')?.hasError('required') && KYCForm?.get('cinNumber')?.touched">
                        CIN Number is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Category Of Business<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <mat-select placeholder="Select" formControlName="categoryOfBusiness">
                        <mat-option value="" [disabled]="true">Select Category Of Business</mat-option>
                        <mat-option *ngFor="let category of categoryOfBusiness" [value]="category.name">{{ category.name }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('categoryOfBusiness')?.hasError('required') && KYCForm?.get('categoryOfBusiness')?.touched">
                        Category Of Business is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" *ngIf="showBusinessOthers">
                  <div class="formGroup">
                    <label class="flex">Category of Business Others<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="businessOthers" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('businessOthers')?.hasError('required') && KYCForm?.get('businessOthers')?.touched">
                        Category of Business Others is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-12">
                <lucide-icon name="MapPin" class="user_icon"></lucide-icon>
                Registered Address
              </h4>
              <div class="row">
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Company Name<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="regCompName" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('regCompName')?.hasError('required') && KYCForm?.get('regCompName')?.touched">
                        Company Address is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Building<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="regBuilding" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('regBuilding')?.hasError('required') && KYCForm?.get('regBuilding')?.touched">
                        Building is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Street<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="regCompStreet" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('regCompStreet')?.hasError('required') && KYCForm?.get('regCompStreet')?.touched">
                        Street is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Zipcode<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="15" formControlName="regCompPincode" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('regCompPincode')?.hasError('required') && KYCForm?.get('regCompPincode')?.touched">
                        Zipcode is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Country<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <mat-select placeholder="Select Country" formControlName="regCompCountry">
                        <mat-option value="" [disabled]="true">Select Country</mat-option>
                        <mat-option *ngFor="let country of countryData" [value]="country?.countryName"
                          ><span>{{ country?.countryName }}</span></mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('regCompCountry')?.hasError('required') && KYCForm?.get('regCompCountry')?.touched">
                        Country is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Authorised Person Name<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="regCompAuthPerson" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('regCompAuthPerson')?.hasError('required') && KYCForm?.get('regCompAuthPerson')?.touched">
                        Authorised Person Name is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Designation<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="regCompDesignation" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('regCompDesignation')?.hasError('required') && KYCForm?.get('regCompDesignation')?.touched">
                        Designation is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Email<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="regCompEmail" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('regCompEmail')?.hasError('required') && KYCForm?.get('regCompEmail')?.touched">
                        Email is required
                      </div>
                      <div
                        *ngIf="
                          KYCForm?.get('regCompEmail')?.value != '' &&
                          (KYCForm?.get('regCompEmail')?.hasError('email') || KYCForm.get('regCompEmail')?.hasError('numericAfterDotCom'))
                        "
                      >
                        Must be a valid email address
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Mobile No.<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="15" formControlName="regCompMobile" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('regCompMobile')?.hasError('required') && KYCForm?.get('regCompMobile')?.touched">
                        Mobile No. is required
                      </div>
                      <div *ngIf="KYCForm?.get('regCompMobile')?.value != '' && KYCForm?.get('regCompMobile')?.hasError('pattern')">
                        Must be a valid number
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Office Telephone No.<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="regCompTelephone" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('regCompTelephone')?.hasError('required') && KYCForm?.get('regCompTelephone')?.touched">
                        Office Telephone No. is required
                      </div>
                      <div
                        *ngIf="
                          KYCForm?.get('regCompTelephone')?.value != '' &&
                          (KYCForm?.get('regCompTelephone')?.hasError('pattern') ||
                            KYCForm?.get('regCompTelephone')?.hasError('minlength') ||
                            KYCForm?.get('regCompTelephone')?.hasError('maxlength'))
                        "
                      >
                        Must be a valid number
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-12">
                <lucide-icon name="MapPin" class="user_icon"></lucide-icon>
                Correspondence Address
              </h4>
              <div class="row">
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Company Name<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="corCompName" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('corCompName')?.hasError('required') && KYCForm?.get('corCompName')?.touched">
                        Company Name is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Building<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="corBuilding" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('corBuilding')?.hasError('required') && KYCForm?.get('corBuilding')?.touched">
                        Building is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Street<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="corCompStreet" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('corCompStreet')?.hasError('required') && KYCForm?.get('corCompStreet')?.touched">
                        Street is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">ZipCode<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="15" formControlName="corCompPincode" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('corCompPincode')?.hasError('required') && KYCForm?.get('corCompPincode')?.touched">
                        Zipcode is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Country<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <mat-select placeholder="Select Country" formControlName="corCompCountry">
                        <mat-option value="" [disabled]="true">Select Country</mat-option>
                        <mat-option *ngFor="let country of countryData" [value]="country?.countryName"
                          ><span>{{ country?.countryName }}</span></mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('corCompCountry')?.hasError('required') && KYCForm?.get('corCompCountry')?.touched">
                        Country is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Authorised Person Name<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="corCompAuthorizedPerson" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div
                        *ngIf="
                          KYCForm?.get('corCompAuthorizedPerson')?.hasError('required') && KYCForm?.get('corCompAuthorizedPerson')?.touched
                        "
                      >
                        Authorised Person Name is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Designation<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="corCompDesignation" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('corCompDesignation')?.hasError('required') && KYCForm?.get('corCompDesignation')?.touched">
                        Designation is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Email<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="corCompEmail" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('corCompEmail')?.hasError('required') && KYCForm?.get('corCompEmail')?.touched">
                        Email is required
                      </div>
                      <div
                        *ngIf="
                          KYCForm?.get('corCompEmail')?.value != '' &&
                          (KYCForm?.get('corCompEmail')?.hasError('email') || KYCForm.get('corCompEmail')?.hasError('numericAfterDotCom'))
                        "
                      >
                        Must be a valid email address
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Mobile No.<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="corCompMobile" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('corCompMobile')?.hasError('required') && KYCForm?.get('corCompMobile')?.touched">
                        Mobile No. is required
                      </div>
                      <div *ngIf="KYCForm?.get('corCompMobile')?.value != '' && KYCForm?.get('corCompMobile')?.hasError('pattern')">
                        Must be a valid number
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Office Telephone No.<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="corCompTelephone" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('corCompTelephone')?.hasError('required') && KYCForm?.get('corCompTelephone')?.touched">
                        Office Telephone No. is required
                      </div>
                      <div
                        *ngIf="
                          KYCForm?.get('corCompTelephone')?.value != '' &&
                          (KYCForm?.get('corCompTelephone')?.hasError('pattern') ||
                            KYCForm?.get('corCompTelephone')?.hasError('minlength') ||
                            KYCForm?.get('corCompTelephone')?.hasError('maxlength'))
                        "
                      >
                        Must be a valid number
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-12">
                <lucide-icon name="Landmark" class="user_icon"></lucide-icon>
                Finance & Bank Details
              </h4>
              <div class="row">
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Tax Number Type<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <mat-select placeholder="Select " formControlName="taxType">
                        <mat-option value="" [disabled]="true">Select Tax Number Type</mat-option>
                        <mat-option *ngFor="let number of taxNumberData" [value]="number.name">{{ number.name }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('taxType')?.hasError('required') && KYCForm?.get('taxType')?.touched">
                        Tax Number Type is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Tax Number<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="taxNumber" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('taxNumber')?.hasError('required') && KYCForm?.get('taxNumber')?.touched">
                        Tax Number is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Legal Status of the Company<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <mat-select placeholder="Select" formControlName="legalStatus">
                        <mat-option value="" [disabled]="true">Select Legal Status</mat-option>
                        <mat-option *ngFor="let status of legalStatus" [value]="status.name">{{ status.name }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('legalStatus')?.hasError('required') && KYCForm?.get('legalStatus')?.touched">
                        Legal Status of the Company is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Bank Name<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="bankName" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('bankName')?.hasError('required') && KYCForm?.get('bankName')?.touched">
                        Bank Name is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Account Number<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="accountNumber" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('accountNumber')?.hasError('required') && KYCForm?.get('accountNumber')?.touched">
                        Account Number is required
                      </div>
                      <div *ngIf="KYCForm?.get('accountNumber')?.value != '' && KYCForm?.get('accountNumber')?.hasError('pattern')">
                        Must be a valid number
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">IBAN Number<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="ibanNumber" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('ibanNumber')?.hasError('required') && KYCForm?.get('ibanNumber')?.touched">
                        IBAN Number is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Swift Code/Bank Code<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="swiftCode" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('swiftCode')?.hasError('required') && KYCForm?.get('swiftCode')?.touched">
                        Swift Code/Bank Code is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Bank Address<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="bankAddress" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('bankAddress')?.hasError('required') && KYCForm?.get('bankAddress')?.touched">
                        Bank Address is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Name of the firm as per bank records<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" formControlName="nameAsPerRecord" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('nameAsPerRecord')?.hasError('required') && KYCForm?.get('nameAsPerRecord')?.touched">
                        Name of the firm as per bank records is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Cancelled Cheque Copy<sup>*</sup></label>
                    <!-- <mat-form-field appearance="outline">
                                      </mat-form-field> -->
                    <input
                      type="file"
                      formControlName="cancelledCheque"
                      #cancelledChequeFileSelector
                      (change)="getCancelledCheque($event)"
                    />
                    <div class="errorTxt">
                      <div
                        *ngIf="
                          KYCForm?.get('cancelledCheque')?.hasError('required') &&
                          KYCForm?.get('cancelledCheque')?.touched &&
                          !kycData?.kycAttachment
                        "
                      >
                        Cancelled Cheque Copy is required
                      </div>
                    </div>
                    <div class="flex file-upload-status alignCenter" *ngIf="cancelledCheque">
                      <div class="col-lg-7 col-md-12 col-sm-12 flex alignCenter">
                        <span class="file-name" matTooltip="{{ cancelledCheque.name }}" matTooltipPosition="left">
                          {{ cancelledCheque.name }}</span
                        >
                      </div>
                      <div>
                        {{ formatBytes(cancelledCheque.size) }}
                      </div>
                      <mat-icon (click)="deleteAttachedFile()">delete</mat-icon>
                      <mat-icon (click)="downloadAttachedFile()">save_alt</mat-icon>
                    </div>
                    <div class="file-upload-status flex alignCenter" *ngIf="!cancelledCheque && kycData?.kycAttachment?.fileName">
                      <div class="col-lg-7 col-md-12 col-sm-12 flex alignCenter">
                        <span class="file-name" matTooltip="{{ kycData?.kycAttachment?.fileName }}" matTooltipPosition="left">
                          {{ kycData?.kycAttachment?.fileName }}</span
                        >
                      </div>
                      <div class="col-lg-5 col-md-12 col-sm-12 file-upload-size-info flex alignCenter">
                        <span class="file-size"> {{ kycData?.kycAttachment?.size }}</span>
                        <span (click)="deleteAttachedFile()">
                          <mat-icon>delete</mat-icon>
                        </span>
                        <span (click)="downloadKycFile(kycData?.kycAttachment?.id, kycData?.kycAttachment?.fileName)">
                          <mat-icon>save_alt</mat-icon>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <label class="flex">Annual Turnover (last 3 years, in USD)</label>
              <div class="row">
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Year<sup>*</sup></label>
                    <mat-form-field appearance="outline" class="disable">
                      <mat-select placeholder="Select" formControlName="yearOne">
                        <mat-option value="">Select</mat-option>
                        <mat-option *ngFor="let year of lastThreeYears" [value]="year">{{ year }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('yearOne')?.hasError('required') && KYCForm?.get('yearOne')?.touched">Year is required</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Amount<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" type="number" formControlName="yearOneRevenue" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('yearOneRevenue')?.hasError('required') && KYCForm?.get('yearOneRevenue')?.touched">
                        Amount is required
                      </div>
                      <div *ngIf="KYCForm?.get('yearOneRevenue')?.hasError('pattern') && KYCForm?.get('yearOneRevenue')?.touched">
                        Must be a valid amount
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Year<sup>*</sup></label>
                    <mat-form-field appearance="outline" class="disable">
                      <mat-select placeholder="Select Year" formControlName="yearTwo">
                        <mat-option value="">Select</mat-option>
                        <mat-option *ngFor="let year of lastThreeYears" [value]="year">{{ year }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('yearTwo')?.hasError('required') && KYCForm?.get('yearTwo')?.touched">Year is required</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Amount<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" type="number" formControlName="yearTwoRevenue" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('yearTwoRevenue')?.hasError('required') && KYCForm?.get('yearTwoRevenue')?.touched">
                        Amount is required
                      </div>
                      <div *ngIf="KYCForm?.get('yearTwoRevenue')?.hasError('pattern') && KYCForm?.get('yearTwoRevenue')?.touched">
                        Must be a valid amount
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Year<sup>*</sup></label>
                    <mat-form-field appearance="outline" class="disable">
                      <mat-select placeholder="Select Year" formControlName="yearThree">
                        <mat-option value="">Select</mat-option>
                        <mat-option *ngFor="let year of lastThreeYears" [value]="year">{{ year }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('yearThree')?.hasError('required') && KYCForm?.get('yearThree')?.touched">
                        Year is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Amount<sup>*</sup></label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" type="number" formControlName="yearThreeRevenue" matInput />
                    </mat-form-field>
                    <div class="errorTxt">
                      <div *ngIf="KYCForm?.get('yearThreeRevenue')?.hasError('required') && KYCForm?.get('yearThreeRevenue')?.touched">
                        Amount is required
                      </div>
                      <div *ngIf="KYCForm?.get('yearThreeRevenue')?.hasError('pattern') && KYCForm?.get('yearThreeRevenue')?.touched">
                        Must be a valid amount
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </mat-tab>
      <mat-tab label="Finances" *ngIf="financeTab">
        <div class="tabInner">
          <form [formGroup]="financeProfileForm">
            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-12">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M2.33301 11.3332V6.6665H3.66634V11.3332H2.33301ZM6.33301 11.3332V6.6665H7.66634V11.3332H6.33301ZM0.333008 13.9998V12.6665H13.6663V13.9998H0.333008ZM10.333 11.3332V6.6665H11.6663V11.3332H10.333ZM0.333008 5.33317V3.99984L6.99967 0.666504L13.6663 3.99984V5.33317H0.333008ZM3.29967 3.99984H10.6997L6.99967 2.1665L3.29967 3.99984Z"
                    fill="#E14D54"
                  />
                </svg>
                Bank Details
              </h4>
              <div class="row">
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Global VAT</label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" matInput formControlName="globalVat" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Currency </label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" matInput formControlName="currency" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Bank Name</label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" matInput formControlName="bankName" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Account Number</label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" matInput formControlName="accountNo" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">Bank Code</label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" matInput formControlName="ifscCode" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="formGroup">
                    <label class="flex">PAN</label>
                    <mat-form-field appearance="outline">
                      <input maxlength="200" matInput formControlName="pan" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-3">
                  <!-- <div class="formGroup">
                        <label class="flex">Cancelled cheque</label>
                        <div class="flex alignCenter">
                            <button type="button" mat-icon-button (click)="fileInput.click()">
                                <mat-icon> attach_file</mat-icon>
                            </button>
                            <input hidden (change)="prepareFilesList($event)" #fileInput type="file">
                            <span> {{files[0]?.name}} </span>
                        </div>
                        <button class="ml-5" mat-raised-button color="warn" type="submit" (click)="getFileUploadS3UrlAndUpload()">Upload Cheque</button>
                    </div> -->
                </div>
              </div>
            </div>
            <h4 class="itemTitle flex alignCenter font-12">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_538_8573)">
                  <path
                    d="M7.19366 10.1133C7.06033 10.1133 6.93366 10.06 6.84033 9.96667L5.22703 8.35333C5.0337 8.16 5.0337 7.84 5.22703 7.64667C5.42036 7.45333 5.74036 7.45333 5.9337 7.64667L7.19366 8.90667L10.0603 6.04002C10.2537 5.84669 10.5737 5.84669 10.767 6.04002C10.9603 6.23335 10.9603 6.55335 10.767 6.74667L7.547 9.96667C7.45366 10.06 7.327 10.1133 7.19366 10.1133Z"
                    fill="#E14D54"
                  />
                  <path
                    d="M8.00027 15.1668C7.58027 15.1668 7.16027 15.0268 6.83361 14.7468L5.78025 13.8402C5.67358 13.7468 5.40691 13.6535 5.26691 13.6535H4.12025C3.13358 13.6535 2.33358 12.8535 2.33358 11.8668V10.7268C2.33358 10.5868 2.24025 10.3268 2.14691 10.2202L1.24691 9.16016C0.700247 8.5135 0.700247 7.4935 1.24691 6.84683L2.14691 5.78683C2.24025 5.68016 2.33358 5.42016 2.33358 5.28016V4.1335C2.33358 3.14683 3.13358 2.34683 4.12025 2.34683H5.27358C5.41358 2.34683 5.68025 2.24683 5.78691 2.16016L6.84027 1.2535C7.49361 0.693496 8.51361 0.693496 9.16694 1.2535L10.2203 2.16016C10.3269 2.2535 10.5936 2.34683 10.7336 2.34683H11.8669C12.8536 2.34683 13.6536 3.14683 13.6536 4.1335V5.26683C13.6536 5.40683 13.7536 5.6735 13.8469 5.78016L14.7536 6.8335C15.3136 7.48683 15.3136 8.50683 14.7536 9.16016L13.8469 10.2135C13.7536 10.3202 13.6536 10.5868 13.6536 10.7268V11.8602C13.6536 12.8468 12.8536 13.6468 11.8669 13.6468H10.7336C10.5936 13.6468 10.3269 13.7468 10.2203 13.8335L9.16694 14.7402C8.84027 15.0268 8.42027 15.1668 8.00027 15.1668ZM4.12025 3.34683C3.68691 3.34683 3.33358 3.70016 3.33358 4.1335V5.2735C3.33358 5.6535 3.15358 6.14016 2.90691 6.42683L2.00691 7.48683C1.77358 7.76016 1.77358 8.2335 2.00691 8.50683L2.90691 9.56683C3.15358 9.86016 3.33358 10.3402 3.33358 10.7202V11.8602C3.33358 12.2935 3.68691 12.6468 4.12025 12.6468H5.27358C5.66025 12.6468 6.14691 12.8268 6.44025 13.0802L7.49361 13.9868C7.76694 14.2202 8.24694 14.2202 8.52027 13.9868L9.57361 13.0802C9.86694 12.8335 10.3536 12.6468 10.7403 12.6468H11.8736C12.3069 12.6468 12.6603 12.2935 12.6603 11.8602V10.7268C12.6603 10.3402 12.8403 9.8535 13.0936 9.56016L14.0003 8.50683C14.2336 8.2335 14.2336 7.7535 14.0003 7.48016L13.0936 6.42683C12.8403 6.1335 12.6603 5.64683 12.6603 5.26016V4.1335C12.6603 3.70016 12.3069 3.34683 11.8736 3.34683H10.7403C10.3536 3.34683 9.86694 3.16683 9.57361 2.9135L8.52027 2.00683C8.24694 1.7735 7.76694 1.7735 7.49361 2.00683L6.44025 2.92016C6.14691 3.16683 5.65358 3.34683 5.27358 3.34683H4.12025Z"
                    fill="#E14D54"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_538_8573">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              KYC Details
            </h4>
            <div class="row">
              <div class="col-md-3">
                <div class="formGroup">
                  <label class="flex">Global VAT</label>
                  <mat-form-field appearance="outline">
                    <input maxlength="200" matInput formControlName="globalVat" />
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-3">
                <div class="formGroup">
                  <label class="flex">PAN</label>
                  <mat-form-field appearance="outline">
                    <input maxlength="200" matInput formControlName="pan" />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </form>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="topBtn">
    <button mat-button class="btnCustom btn-trans" routerLink="../">Back To Profile</button>
    <button mat-button class="btnCustom btn-gray" (click)="resetUserProfileData()" *ngIf="!kycTab">Reset</button>
    <button mat-button class="btnCustom btn-primary" (click)="updateUserData()" *ngIf="!kycTab" [ngClass]="{ disable: isValidUpdate() }">
      Save & Update Profile
    </button>
    <button
      mat-button
      class="btnCustom btn-primary"
      (click)="updateKYC()"
      *ngIf="kycTab"
      [disabled]="KYCForm.invalid || !isKYCValidFiles(kycFilesMap, mandatoryKycKey) || kycData.status === KYCStatus.IN_REVIEW"
    >
      Update KYC Details
    </button>
  </div>
</div>
<ng-template #fileList let-fileKey>
  <div class="" *ngFor="let fileItem of kycData?.kycFiles">
    <div class="file-upload-status flex alignCenter" *ngIf="fileItem.useFor === fileKey">
      <div class="col-lg-5 col-md-12 col-sm-12 flex alignCenter">
        <span class="file-name" matTooltip="{{ fileItem.fileName }}" matTooltipPosition="left"> {{ fileItem?.fileName }}</span>
      </div>
      <div class="col-lg-7 col-md-12 col-sm-12 file-upload-size-info flex alignCenter">
        <span class="file-size"> {{ fileItem?.fileSize }}</span>
        <span (click)="downloadKycFile(fileItem?.fileId, fileItem?.fileName)">
          <mat-icon>save_alt</mat-icon>
        </span>
        <span (click)="deleteKycFileLocal(fileKey, fileItem?.fileId)">
          <mat-icon>delete_outline</mat-icon>
        </span>
      </div>
    </div>
  </div>
</ng-template>
